module.exports.ProfileTabIndexes = {
  GENERAL: 0,
  FACILITIES: 1,
  SETTINGS: 2,
};
